import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import FamilyCommunicationDetails from "./routes/FamilyCommunicationDetails";
export default store => ({
  path: "familyconversations",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "family-conversations" */ "./components"),
        import(
          /* webpackChunkName: "family-conversations" */ "./modules/FamilyConversationsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "familyConversations",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [FamilyCommunicationDetails(store)],
});
